
import { defineComponent } from 'vue';
import { useNodeCanvasStore } from '../store';
import TextBubble from '@/modules/globalModule/components/TextBubble.vue';
  export default defineComponent({
    name: "PullCodes",
    components: {
      TextBubble
    },
    data() {
      return {
        ncStore: useNodeCanvasStore(),
        isInfoActive: true
      }
    }
  })
